// extracted by mini-css-extract-plugin
module.exports =  {"root":"krgBoiLyz_piW8YtYYMx","details":"kVxCa0fqrOSBBsSK4gqH","content":"iUP9l8TBmOf8wiQXI0XE","title":"msuDgyhqPS_tDBgwovs3","organization":"rRP6KvyH099ov86yFIWG"};